const { Search } = require("@mui/icons-material");
const { Button } = require("@mui/material")
const { useTranslation } = require("react-i18next")

const IndieSearchButton = ({label, ...params}) => {
    const { t } = useTranslation();
    return <Button sx={{maxWidth:200}} startIcon={<Search/>} variant={params.variant ? params.variant : "outlined"} {...params}>{label ? label : t("label.button.search")}</Button>
}

export default IndieSearchButton;